angular.module('clients')
    .component('clientNameListFormat', {
        bindings: {
            clients: '<',
        },
        template: `
            <div class="client-name-list">
                <div ng-repeat="c in $ctrl.clients track by c.id" style="color: #333333; font-size: smaller;">
                    <i ng-if="$ctrl.clients.length > 1" class="fa fa-angle-right fa-fw fa-lg"></i>{{c.fullName}}
                </div>
            </div>
        `
    })
